import React, { Component } from 'react'
import './index.scss'

export class index extends Component {
  state = {}
  componentWillMount() {}

  render() {
    return (
      <div className="mytypeArea Advantage" style={{ margin: ' 0 auto' }}>
        <div className="Advantage-title">
          <div className="Advantage-title-h1">我们的优势</div>
          <div className="Advantage-title-text">OUR ADVANTAGES </div>
        </div>
        <div className="Advantage-content">
          <div className="Advantage-content-item">
            <img className="Advantage-content-item-img" src={require('../../../image/icon性价比-蓝.png')} alt="" />
            <div className="Advantage-content-item-title">更高的性价比</div>
            <div className="Advantage-content-item-content">为客户提供更灵活的合作方式和更高性价比的定制服务。</div>
          </div>
          <div className="Advantage-content-item">
            <img className="Advantage-content-item-img" src={require('../../../image/icon视觉-蓝.png')} alt="" />
            <div className="Advantage-content-item-title">更好的视觉表现</div>
            <div className="Advantage-content-item-content">基于自研数字渲染引擎可以让您的项目拥有游戏级的视觉呈现。</div>
          </div>
          <div className="Advantage-content-item">
            <img className="Advantage-content-item-img" src={require('../../../image/icon部署-蓝.png')} alt="" />
            <div className="Advantage-content-item-title">更简单的部署</div>
            <div className="Advantage-content-item-content">基于自研平台架构，可以实现本地一键私有化部署。</div>
          </div>
          <div className="Advantage-content-item" style={{ margin: '0px', borderRight: 'none', padding: '0px' }}>
            <img className="Advantage-content-item-img" src={require('../../../image/icon扩展-蓝.png')} alt="" />
            <div className="Advantage-content-item-title">更强的扩展性</div>
            <div className="Advantage-content-item-content">提供了从大屏组件元素二次开发接口，支持集成第三方系统。</div>
          </div>
        </div>
      </div>
    )
  }
}

export default index
